<script lang="ts">
  import type { Listing } from '../lib/types';
  import type { TriageAction } from '../lib/stores/triage';
  import { derive } from '../lib/stores/triage';
  import { priceUSD, brandLabel, relativeAge, platformDisplayName } from '../lib/format';

  let {
    listing,
    selected = false,
    onAct,
    onOpen,
  }: {
    listing: Listing;
    selected?: boolean;
    onAct: (action: TriageAction) => void;
    onOpen: () => void;
  } = $props();

  const d = $derived(derive(listing));

  function fire(action: TriageAction) {
    return (event: MouseEvent) => {
      event.stopPropagation();
      onAct(action);
    };
  }
</script>

<div
  class="tile"
  class:seen={d.seen && !d.saved}
  class:saved={d.saved}
  data-kbd={selected ? '' : null}
>
  <div class="shot" class:is-empty={!listing.primary_image_url}>
    <button class="opener" type="button" aria-label="Xem chi tiết: {listing.title}" onclick={onOpen}></button>
    {#if listing.primary_image_url}
      <img src={listing.primary_image_url} alt={listing.title} loading="lazy" />
    {:else}
      &#9200;
    {/if}
    {#if listing.tier !== 1}
      <span class="tierdot" title="tầng tin cậy {listing.tier}"></span>
    {/if}
    {#if d.saved}
      <span class="savemark" aria-hidden="true">&#9733;</span>
    {/if}
    <span class="mk">{brandLabel(listing)}</span>
    <div class="over">
      <span class="ttl">{listing.title}</span>
      <div class="acts">
        <button type="button" onclick={fire('save')}>{d.saved ? '★ Bỏ lưu' : '★ Lưu'}</button>
        <button type="button" onclick={fire('hide')}>✕ Ẩn</button>
        <button type="button" onclick={fire('open')}>↗ {platformDisplayName(listing.platform)}</button>
      </div>
      <span class="hint">s · x · o · enter</span>
    </div>
  </div>
  <div class="strip">
    <span class="price">{priceUSD(listing.price_usd)}</span>
    <span class="age">{relativeAge(listing.listed_at)}</span>
    <span class="pdot" class:pdot-poshmark={listing.platform === 'poshmark'} title={platformDisplayName(listing.platform)}></span>
  </div>
</div>

<style>
  /* Structural deltas from the prototype's nested-button tile. */
  .tile .opener {
    position: absolute;
    inset: 0;
    z-index: 1;
    background: none;
    border: 0;
    padding: 0;
  }
  .tile .over {
    z-index: 2;
  }
  .tile .mk,
  .tile .tierdot,
  .tile .savemark {
    pointer-events: none;
  }
</style>
